export const CONTACTS_REQUESTED = 'CONTACTS_REQUESTED'
export const CONTACTS_RECEIVED = 'CONTACTS_RECEIVED'
export const CONTACT_UPDATED = 'CONTACT_UPADTED'
